import styled from "@emotion/styled";

export const ErrorText = styled.p`
  color: red;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
`;
